import React from 'react';
import ModalTitle from 'components/modal/components/ModalTitle';
import { useTranslation } from 'hooks';
import ModalContent from 'components/modal/components/ModalContent';
import ModalFooter from 'components/modal/components/ModalFooter';
import Button from 'components/ui/button';
import { closeModal } from 'actions/modal';

interface Props {
  callback: (value?: boolean) => void;
}

export const SuggestToSaveOnboardingForm: React.FC<Props> = ({ callback }) => {
  const getTranslate = useTranslation();

  return (
    <>
      <ModalTitle customClass='w-full text-center'>
        {getTranslate('modals.common.title')}
      </ModalTitle>
      <ModalContent customClass='w-full text-center'>
        {getTranslate('modals.common.description')}
      </ModalContent>
      <ModalFooter>
        <Button
          text={getTranslate('common.cancel.button')}
          status='outline'
          size='normal'
          onClick={() => {
            closeModal();
            callback();
          }}
        />
        <Button
          text={getTranslate('common.save.button')}
          status='primary'
          size='normal'
          onClick={() => callback(true)}
        />
      </ModalFooter>
    </>
  );
};
